module.exports = __webpack_public_path__ + "static/media/vulve-complette.cd93d095.png";